import { render, staticRenderFns } from "./CostDetails.vue?vue&type=template&id=466fe364&scoped=true&"
import script from "./CostDetails.vue?vue&type=script&lang=js&"
export * from "./CostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466fe364",
  null
  
)

export default component.exports